import { Component, OnInit } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PASSWORD_LENGTH_LIMIT } from '@zlib/data-access/constants';
import { ResetPassword } from '@zlib/data-access/models/user.model';
import { AuthService } from '@zlib/services/auth.service';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    imports: [
        NzFormModule,
        FormsModule,
        ReactiveFormsModule,
        NzInputModule,
        NzIconModule,
        TranslateModule
    ]
})
export class ResetPasswordComponent implements OnInit {
    validateNewPasswordForm!: UntypedFormGroup;
    newPasswordVisible = false;
    confirmNewPasswordVisible = false;
    resetPasswordModel: ResetPassword = {
        token: '',
        newPassword: ''
    };

    constructor(
        private formbuilder: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params) => {
            const token = params['token'];
            if (token) {
                this.resetPasswordModel.token = token;
            }
        });

        this.validateNewPasswordForm = this.formbuilder.group({
            newPassword: [null, [Validators.required, this.strongPassword]],
            confirmNewPassword: [
                null,
                [Validators.required, this.passwordConfirmValidator]
            ]
        });
    }

    strongPassword = (
        control: UntypedFormControl
    ): { [s: string]: boolean } => {
        const lengthRequired =
            (control?.value?.length ?? 0) >= PASSWORD_LENGTH_LIMIT;
        if (!control.value) {
            return { required: true };
        } else if (!lengthRequired) {
            return { length: true };
        }
        return {};
    };

    passwordConfirmValidator = (
        control: UntypedFormControl
    ): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        } else if (
            control.value !==
            this.validateNewPasswordForm.controls['newPassword'].value
        ) {
            return { confirm: true, error: true };
        }
        return {};
    };

    clearNewPassword(): void {
        this.validateNewPasswordForm.reset();
    }

    onConfirmNewPassword(): void {
        if (this.validateNewPasswordForm.valid) {
            const { newPassword }: { newPassword: string } =
                this.validateNewPasswordForm.value;
            this.resetPasswordModel.newPassword = newPassword;
            this.authService
                .resetPassword(this.resetPasswordModel)
                .subscribe((res) => {
                    if (res) {
                        this.router.navigate(['/auth/login']);
                    }
                });
        } else {
            this.validateForm(this.validateNewPasswordForm);
        }
    }

    validateForm(formGroup: UntypedFormGroup): void {
        Object.values(formGroup.controls).forEach((control) => {
            if (control.invalid) {
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
            }
        });
    }
}
